(() => {
  "use strict";

  const SELECTOR = "[data-peguu-validation-alert]";
  const CLOSE_SELECTOR = "[data-validation-alert-close]";
  let activeElement = null;
  let alertElement = null;

  const getAlert = () => {
    if (!alertElement || !document.body.contains(alertElement)) {
      alertElement = document.querySelector(SELECTOR);
    }

    return alertElement;
  };

  const close = (targetAlert = null) => {
    const alert = targetAlert || getAlert();

    if (!alert) {
      return;
    }

    alert.classList.remove("is-visible");
    alert.hidden = true;

    if (activeElement && typeof activeElement.focus === "function") {
      activeElement.focus({ preventScroll: true });
    }

    activeElement = null;
  };

  const handleCloseClick = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const trigger = target.closest(CLOSE_SELECTOR);
    const alert = trigger?.closest(SELECTOR);

    if (!trigger || !alert) {
      return;
    }

    event.preventDefault();
    close(alert);
  };

  const open = ({
    title = "Faltan datos para continuar",
    message = "Para continuar, complete los campos de:",
    fields = [],
    showFields = true,
  } = {}) => {
    initialize();

    const alert = getAlert();

    if (!alert) {
      return;
    }

    const titleElement = alert.querySelector("[data-validation-alert-title]");
    const messageElement = alert.querySelector("[data-validation-alert-message]");
    const fieldsElement = alert.querySelector("[data-validation-alert-fields]");
    const closeButton = alert.querySelector(CLOSE_SELECTOR);
    const normalizedFields = Array.isArray(fields) ? fields : [fields];
    const fieldsText = normalizedFields
      .map((field) => String(field || "").trim())
      .filter(Boolean)
      .join(" · ");

    if (titleElement) {
      titleElement.textContent = title;
    }

    if (messageElement) {
      messageElement.textContent = message;
      messageElement.hidden = !message;
    }

    if (fieldsElement) {
      fieldsElement.textContent = fieldsText;
      fieldsElement.hidden = !showFields || !fieldsText;
    }

    activeElement = document.activeElement;
    alert.hidden = false;
    alert.classList.add("is-visible");
    closeButton?.focus({ preventScroll: true });
  };

  const bind = () => {
    const alert = getAlert();

    if (!alert || alert.dataset.validationAlertBound === "true") {
      return;
    }

    alert.dataset.validationAlertBound = "true";

    document.addEventListener(
      "click",
      handleCloseClick,
      true
    );

    alert.addEventListener("click", (event) => {
      if (event.target === alert) {
        close();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && alert.classList.contains("is-visible")) {
        close();
      }
    });
  };

  const initialize = () => {
    const alert = getAlert();

    if (!alert) {
      return;
    }

    if (alert.parentElement !== document.body) {
      document.body.appendChild(alert);
    }

    bind();
  };

  window.PeguuValidationAlert = {
    open,
    close,
    initialize,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
